import React from 'react';
import { toPlainText } from '~/lib/helpers';
import ArticleHeader from '../../components/ArticleHeader';
import { Link, SubParagraph, SmallText } from '@entur/typography';
import { ZonedDateTime, nativeDateToDateValue } from '@entur/datepicker';
import { Badge } from '@entur/layout';
import './Blogpost.scss';
import ContentWrapper from '../../components/ContentWrapper';
import { urlFor } from '../../components/ImageURL';
import PortableText from '../../components/PortableText';
import { ArticleType } from '~/components/sanity/types';

const Blogpost: React.FC<ArticleType> = (props) => {
  const {
    _rawBody,
    _rawExcerpt,
    title,
    mainImage,
    alt,
    author,
    publishedAt,
    _updatedAt,
    showUpdatedAt,
  } = props;

  // Get author name and email
  const authorName = author && author.name ? author.name : '';
  const authorEmail = author && author.email ? author.email : '';

  // Update _updatedAt to correct timezone and format
  const updatedDate = nativeDateToDateValue(
    new Date(_updatedAt),
    false,
    'Europe/Oslo'
  ) as ZonedDateTime | null;

  const convertedUpdatedDate =
    updatedDate?.day?.toString().padStart(2, '0') +
    '.' +
    updatedDate?.month?.toString().padStart(2, '0') +
    '.' +
    updatedDate?.year?.toString().padStart(2, '0') +
    ' ' +
    updatedDate?.hour?.toString().padStart(2, '0') +
    ':' +
    updatedDate?.minute?.toString().padStart(2, '0');

  return (
    <>
      <ArticleHeader
        title={title}
        excerpt={toPlainText(_rawExcerpt)}
        imageSrc={urlFor(mainImage.asset).fit('crop').crop('focalpoint').url()}
        alt={alt ?? ''}
      />
      <ContentWrapper>
        <div className="blogpost-date">
          <div className="blogpost-date__dates">
            {publishedAt && (
              <SubParagraph margin="none">Publisert {publishedAt}</SubParagraph>
            )}

            {showUpdatedAt && (
              <Badge variant="info" type="status">
                Endret {convertedUpdatedDate}
              </Badge>
            )}
          </div>
          {authorName && authorEmail && (
            <SmallText className="blogpost-date__author" margin="none">
              <Link href={`mailto:${authorEmail}`}>{authorName}</Link>
            </SmallText>
          )}
          {authorName && !authorEmail && (
            <SmallText className="blogpost-date__author" margin="none">
              {authorName}
            </SmallText>
          )}
        </div>

        {_rawBody && <PortableText disableFade blocks={_rawBody} />}
      </ContentWrapper>
    </>
  );
};

export default Blogpost;
